import service from '@/store/services/profile-service';

const state = {
    me: null,
    permissions: [],
    roles: []
};

const mutations = {
    SET_RESOURCE: (state, me) => {
        state.me = me;
        state.permissions = me.allPermissions.map(p => p.name);
        state.roles = me.roles.map(r => r.name);
        state.department = me.model.department;
        if (typeof me.model.department !== 'undefined' && me.model.department != null) {
            state.station = me.model.department.station;
        } else {
            state.station = {};
        }
    }
};

const actions = {
    me ({ commit, dispatch }, params) {
        return service.get(params)
            .then((profile) => {
                commit('SET_RESOURCE', profile.list);
                localStorage.setItem('permissions',profile.list.allPermissions);
            });
    },

    permissions ({ commit, dispatch }, params) {
        return service.get(params)
            .then((permissions) => {
                commit('SET_RESOURCE', permissions.list);
            });
    },
    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((profile) => {
                commit('SET_RESOURCE', profile);
            });
    },
};

const getters = {
    me: state => state.me,
    permissions: state => state.permissions,
    roles: state => state.roles,
    department: state => state.department,
    station: state => state.station,
    isDefaultPassword (state) {
        return state.default_password;
    },
};

const profile = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default profile;
